import {
    ALL_MATCHDAY_MARKETS,
    HANDICAP,
    HANDICAP_FIRST,
    HANDICAP_SECOND,
    UNDER_OVER,
    UNDER_OVER_05,
    UNDER_OVER_15,
    UNDER_OVER_25,
    UNDER_OVER_35
} from '../constants/marketTypes';


export function getMarketsByCode(marketCode, markets) {
    let marketsByCode = [];
    if (marketCode && markets && markets.length) {
        for (let i = 0; i < markets.length; i++) {

            if (marketCode.code === UNDER_OVER.code && (markets[i].id.substring(0, 2) === UNDER_OVER_05.code || markets[i].id.substring(0, 2) === UNDER_OVER_15.code || markets[i].id.substring(0, 2) === UNDER_OVER_25.code || markets[i].id.substring(0, 2) === UNDER_OVER_35.code)) {
                marketsByCode.push(markets[i]);
            }
            if (marketCode.code === HANDICAP.code && (markets[i].id.substring(0, 2) === HANDICAP_FIRST.code ||
                markets[i].id.substring(0, 2) === HANDICAP_SECOND.code)) {
                marketsByCode.push(markets[i]);
            } else {
                // check if there are markets for the given code
                if (markets[i].id.substring(0, marketCode.code.length) === marketCode.code) {
                    marketsByCode.push(markets[i]);
                }
            }
        }
        if (marketCode.code === UNDER_OVER.code && marketsByCode.length) {
            let marketsCodeAux = marketsByCode.filter((mks) => mks.id.substring(0, 2) === UNDER_OVER_05.code);
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 2) === UNDER_OVER_15.code));
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 2) === UNDER_OVER_25.code));
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 2) === UNDER_OVER_35.code));
            // marketsByCode.sort((a, b) => a.id.substring(0, 2) - b.id.substring(0, 2));
            marketsByCode = marketsCodeAux;
        }
    }
    return marketsByCode;
}

export function areFootballMarketsExpanded(footballMarketsExpanded) {
    let expanded = true;

    if (footballMarketsExpanded && footballMarketsExpanded.length) {
        expanded = footballMarketsExpanded.find((mkt) => mkt === true);
    }
    return expanded;
}

export function getMarketByCode(code) {
    return ALL_MATCHDAY_MARKETS.filter(market => market.code === code.toString())[0];
}

export function generateRandom(markets, min, max) {
    let selectedMarkets = [];
    markets.forEach(market => {
        let index = Math.floor(Math.random() * (max - min + min) + 1);
        let selectedMarket = {};
        selectedMarket.market = market.market[index - 1];
        selectedMarket.event = market.event;
        selectedMarkets.push(selectedMarket)
    });
    return selectedMarkets;
}

export function generateFav(markets) {
    let selectedMarkets = [];
    markets.forEach(market => {
        let selectedMarket = {};
        selectedMarket.market = JSON.parse(JSON.stringify(market.market)).sort((a, b) => parseFloat(a.odds) - parseFloat(b.odds))[0];
        selectedMarket.event = market.event;
        selectedMarkets.push(selectedMarket);
    });
    return selectedMarkets;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/helpers/marketHelpers.js